<template>
  <config-wrap :title="label">


<!--    {{mValue.dataList}}-->

    <div class="nav">

      <draggable v-model="mValue.dataList">
          <div v-for="item in mValue.dataList" :key="item.id" class="nav-item">
            <div style="display: flex;">
              <div style="margin-right: 6px;" v-for="(val, key, index) in mValue.child" :key="index"
                v-if="val.type == 'upload'">
                <component :is="typeToComponent[val.type]" v-model="item[key]" v-bind="val"></component>
              </div>

              <div>
                <div v-if="val.type != 'upload'" v-for="(val, key, index) in mValue.child" :key="index" >
<!--                  {{item[key]}}-->
                  <component :is="typeToComponent[val.type]" v-model="item[key]"
                             v-bind="val" :disabled="true"
                    :width="val.type == 'color' ? '185px' : ''"></component>

                </div>
              </div>
            </div>


          </div>
      </draggable>



    </div>
  </config-wrap>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";
import typeToComponent from "@/config/schema-template";
import {getCategoryList} from "../../../api/easyApp";

export default {
  name: "SchemaListByDataMapper",
  mixins: [schemaMixin],
  props: {
    label: {
      type: String,
      default: "",
    },
    edit: {
      type: Boolean,
      default: false,
    },
    schema: {
      type: Object,
      default: () => { },
    },
  },
  watch: {
    "control.curWidget.attrs.dataSource.tagSource": {
      handler(newValue, oldValue) {
        //console.log("this.mValue.dataList:",this.mValue.dataList);
        //console.log("==newValue==:",newValue,"==oldValue==:",oldValue);
        console.log("this.mValue.tagSource:",this.mValue.tagSource);
        console.log("==newValue==:",newValue);
        console.log("==oldValue==:",oldValue);

         if(newValue&&newValue!=oldValue){

           if(this.mValue.tagSource!=newValue){
             this.mValue.tagSource=this.control.curWidget.attrs.dataSource.tagSource;
             if(this.control.curWidget.attrs.dataSource) {
               this.mValue.dataList = [];
               this.getTabList();
             }
           }
           else{
             //判断是否value值是否有交叉

           }

         }

      },
      deep: true,
      immediate: true,
    }
  },
  data() {
    return {
      typeToComponent,
      tagSource:""
    };
  },
  inject: ['mode',"control"],
  mounted() {
    /*console.log("重新获取数据");
    console.log("this.control.curWidget.attrs.dataSource:",this.control.curWidget.attrs.dataSource.tagSource);
    console.log("this.mValue.dataList:",this.mValue.dataList);
    console.log("this.tagSource:",this.tagSource);*/

/*    if(this.control.curWidget.attrs.dataSource==this.dataSource){
      return;
    }

    if(this.control.curWidget.attrs.dataSource) {
      this.tagSource=this.control.curWidget.attrs.dataSource.tagSource;
      this.mValue.dataList = [];
      let obj = {}
      for (var i in this.control.curWidget.attrs.dataSource.displayContent) {
        obj = {
          "title": "",
          "value": this.control.curWidget.attrs.dataSource.displayContent[i],
          "image": "https://cdn.zhaosheng.daheyun1314.com/training/4dc8654cd6b142669e3f7b304cd5b0b5.png"
        }
        this.mValue.dataList.push(obj);
      }
    }*/

  },
  methods: {
    async getTabList(){
      let obj = {}

      let url=this.control.curWidget.attrs.dataSource.tagSource.indexOf('allot/userAsset/getAssetBySign/')!=-1?'/allot/userAsset/getAssetBySign/balance':this.control.curWidget.attrs.dataSource.tagSource;

      let data = {
        env: "dev"
      }
      data['url']=url;
      let res=await getCategoryList(data);
      let result=[];
      if (typeof res.data == 'string') {

        let response = JSON.parse(res.data);
        if (response.code == 0) {
          result = response.data;
        } else {
          result = response;
        }

      } else {
        result = res.data;
      }

      let titleObj=this.control.curWidget.attrs.dataSource.dataMapper.find((item) => item.target == 'name');
      let valueObj=this.control.curWidget.attrs.dataSource.dataMapper.find((item) => item.target == 'value');
      let signObj=this.control.curWidget.attrs.dataSource.dataMapper.find((item) => item.target == 'ID');

      console.log("titleObj:",titleObj,valueObj);

      for (var i in result) {
        obj = {
          "sign":signObj.source,
          "title": result[i][titleObj.source],
          "value": result[i][valueObj.source],
          "titleSign":titleObj.source,
          "valueSign":valueObj.source,
          "image": "https://cdn.zhaosheng.daheyun1314.com/training/4dc8654cd6b142669e3f7b304cd5b0b5.png",
          "jump":""
        }
        this.mValue.dataList.push(obj);
      }

    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .p10 {
  padding: 0px 10px !important;
}

::v-deep .config-item {
  margin-bottom: 1px !important;
  padding: 0px;
}
</style>
